import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getThisTag, getOrderSubnavigation, getDailyChallenges } from '../../../../selectors/page';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';

import { Props } from './TagPage';

export type StateProps = Pick<Props, 'tag' | 'hasOrderSubnav' | 'dailyChallenges'>;
export type DispatchProps = Pick<Props, 'pushMiniMuroModal'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  tag: getThisTag(state),
  hasOrderSubnav: !!getOrderSubnavigation(state),
  dailyChallenges: getDailyChallenges(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = dispatch => ({
  pushMiniMuroModal: () => dispatch(pushModal(ModalType.MINI_MURO, {})),
});

export default connect(mapStateToProps, mapDispatchToProps);
